export const ROLES = {
  ATHLETE: 'athlete',
  TRAINER: 'trainer',
  COACH: 'coach',
  ADMIN: 'admin',
  DEV: 'dev',
} as const

const ROLE_ALIASES: Record<string, string> = {
  user: ROLES.ATHLETE,
  public: ROLES.ATHLETE,
}

export const ADMIN_EMAILS = ['sh@haugk.com']

const parseCsv = (raw?: string): string[] =>
  String(raw || '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean)

const TRAINER_FEEDBACK_ALLOWED_EMAILS = parseCsv(import.meta.env.VITE_TRAINER_FEEDBACK_ALLOWED_EMAILS).map((email) => email.toLowerCase())
const TRAINER_FEEDBACK_ALLOWED_USER_IDS = parseCsv(import.meta.env.VITE_TRAINER_FEEDBACK_ALLOWED_USER_IDS)

export const normalizeRole = (role?: string | null): string => {
  const normalized = String(role || '').trim().toLowerCase()
  if (!normalized) return ROLES.ATHLETE
  return ROLE_ALIASES[normalized] || normalized
}

export const getUserRole = (authUser: any): string => {
  const rawRole = authUser?.user_metadata?.role || authUser?.app_metadata?.role || authUser?.role
  return normalizeRole(rawRole)
}

export const isAdminEmail = (email?: string | null): boolean => {
  return ADMIN_EMAILS.includes(email || '')
}

export const hasTrainerAccess = (authUser: any): boolean => {
  const role = getUserRole(authUser)
  return isAdminEmail(authUser?.email) || role === ROLES.TRAINER || role === ROLES.COACH || role === ROLES.ADMIN || role === ROLES.DEV
}

export const hasAdminAccess = (authUser: any): boolean => {
  const role = getUserRole(authUser)
  return isAdminEmail(authUser?.email) || role === ROLES.ADMIN || role === ROLES.DEV
}

export const hasTrainerFeedbackAccess = (authUser: any): boolean => {
  if (!hasTrainerAccess(authUser)) {
    return false
  }

  if (hasAdminAccess(authUser)) {
    return true
  }

  const hasExplicitAllowlist =
    TRAINER_FEEDBACK_ALLOWED_EMAILS.length > 0 ||
    TRAINER_FEEDBACK_ALLOWED_USER_IDS.length > 0

  if (!hasExplicitAllowlist) {
    return true
  }

  const userEmail = String(authUser?.email || '').trim().toLowerCase()
  const userId = String(authUser?.id || '').trim()

  return TRAINER_FEEDBACK_ALLOWED_EMAILS.includes(userEmail) ||
    TRAINER_FEEDBACK_ALLOWED_USER_IDS.includes(userId)
}
